import solicitudServices from "@/services/solicitud.services.js";

// Lógica compartida de la bitácora del cuadro de aportaciones.
// El componente que lo use debe exponer en su contexto:
//   - this.solicitud  (objeto solicitud, con id)
//   - this.setLoader  (mutación utils/setLoader)
// Provee el estado del modal (showBitacora/bitacoraItems) y openBitacora().
export default {
  data() {
    return {
      showBitacora: false,
      bitacoraItems: []
    };
  },
  methods: {
    mapCuadroAportacionesBitacora(cuadro = {}) {
      return {
        nombrePlaza: cuadro.nombrePlaza ?? "",
        salarioMinimo: cuadro.salarioMinimo ?? null,
        salarioMaximo: cuadro.salarioMaximo ?? null,
        calculado_aguinaldo_salario: cuadro.calculado_aguinaldo_salario ?? null,
        aportaciones: {
          honorario: cuadro.honorario ?? null,
          totalHonorariosMensual: cuadro.totalHonorariosMensual ?? null,
          costoPlaza: cuadro.costoPlaza ?? null,
          plazas: cuadro.plazas ?? null,
          costoTotalPlazas: cuadro.costoTotalPlazas ?? null,
          isss: cuadro.isss ?? null,
          afp: cuadro.afp ?? null,
          isr: cuadro.isr ?? null,
          totalIsss: cuadro.totalIsss ?? cuadro.totalPlazaISSS ?? null,
          totalAfp: cuadro.totalAfp ?? cuadro.totalPlazaAFP ?? null,
          totalIsr: cuadro.totalIsr ?? cuadro.totalPlazaISR ?? null,
          aguinaldoIndividual: cuadro.aguinaldoIndividual ?? null,
          aguinaldoTotal: cuadro.aguinaldoTotal ?? null
        }
      };
    },
    mapBitacoraResponse(rawItems = []) {
      return rawItems.map((item, index) => {
        const fechaCruda = item.fecha_modificacion || item.created_at;
        const fechaFormateada = fechaCruda
          ? this.moment(fechaCruda).format("DD/MM/YYYY hh:mm A")
          : "";
        return {
          _uid: item._id ?? index,
          nombres: item.nombre_modificador ?? "",
          cargo: item.cargo ?? "",
          fecha: fechaFormateada,
          comparacion_inicial: this.mapCuadroAportacionesBitacora(
            item.modificaciones?.cuadro_aportaciones_anterior
          ),
          comparacion_final: this.mapCuadroAportacionesBitacora(
            item.modificaciones?.cuadro_aportaciones_nuevo
          )
        };
      });
    },
    async openBitacora() {
      const idSolicitud = this.solicitud?.id;
      if (!idSolicitud) return;
      try {
        this.setLoader(true);
        const response = await solicitudServices.getBitacoraCuadroAportaciones(
          idSolicitud
        );
        if (response?.status === 200) {
          const items = response.data?.data ?? response.data ?? [];
          const rawItems = Array.isArray(items) ? items : [];
          this.bitacoraItems = this.mapBitacoraResponse(rawItems);
          this.showBitacora = true;
        }
      } catch (error) {
        this.temporalAlert({
          show: true,
          message: error?.message || "Error al obtener la bitácora",
          type: "error"
        });
      } finally {
        this.setLoader(false);
      }
    }
  }
};
